module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Training/training-record/training-record-from/training-record-from.component.css
// module id = ./src/app/hrms/Training/training-record/training-record-from/training-record-from.component.css
// module chunks = main